import {post, get} from '@/common/utils/Http';

export default {
  getAllAccountDetail: post('/account/getAllAccountDetail'),
  changeAccount: post('/account/changeAccount'),
  makeUpgradeOrder: post('/account/makeUpgradeOrder'),
  getUpgradeFee: post('/account/getUpgradeFee'),
  getUserTotal: post('/account/getUserTotal'),
  getOrderStatus: post('/account/getOrderStatus'),
  getDefaultDiscount: post('/account/getDefaultDiscount'),
  bindDiscount: post('/account/bindDiscount'),
};
